import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import WkcSend from '@/types/table/wkcSend';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface WkcSendData extends WkcSend {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class WkcSendController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<WkcSendData>>(API_CONTEXT + '/app/wkcSend/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<WkcSendData>(API_CONTEXT + '/app/wkcSend/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/wkcSend/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/wkcSend/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/wkcSend/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcSend/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcSend/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcSend/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcSend/deleteBatch', params, httpOptions);
  }
  static startOnlySend(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcSend/startOnly/send', params, httpOptions);
  }
  static startWithBusinessKeySend(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcSend/startWithBusinessKey/send', params, httpOptions);
  }
  static startAndTakeUserTaskSend(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcSend/startAndTakeUserTask/send', params, httpOptions);
  }
  static startAndSaveDraftSend(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcSend/startAndSaveDraft/send', params, httpOptions);
  }
  static submitUserTaskSend(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcSend/submitUserTask/send', params, httpOptions);
  }
    static editorTakeUserTaskFlowContract(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcSend/editorTakeUserTaskFlowContract/editorTakeUserTaskFlowContract', params, httpOptions);
  }
  static viewTaskBusinessDataSend(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/wkcSend/viewTaskBusinessData/send', params, httpOptions);
  }
  static viewHistoricTaskBusinessDataSend(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/wkcSend/viewHistoricTaskBusinessData/send', params, httpOptions);
  }
  static listWorkOrderSend(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcSend/listWorkOrder/send', params, httpOptions);
  }
   static deleteMessage(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/dept/deleteMessage', params, httpOptions);
  }

    static getSerialNumber(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/wkcSend/getSerialNumber', params, httpOptions);
  }

  static getUserInformation(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<WkcSendData>>(API_CONTEXT + '/app/dept/getUserInformation', params, httpOptions);
  }

   static publishedDataSet(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<WkcSendData>>(API_CONTEXT + '/app/wkcSend/publishedDataSet', params, httpOptions);
  }

}
